// extracted by mini-css-extract-plugin
export default {"container":"i2-z"};